import type { Guide } from "./layout-canvas-utils";

export type LayoutCanvasGuidesProps = {
  guides: Guide[];
  canvasWidth: number;
  canvasHeight: number;
};

export function LayoutCanvasGuides({
  guides,
  canvasWidth,
  canvasHeight,
}: LayoutCanvasGuidesProps) {
  if (!guides.length || !canvasWidth || !canvasHeight) {
    return null;
  }

  return (
    <div className="absolute inset-0 pointer-events-none">
      {guides.map((guide, index) =>
        guide.axis === "x" ? (
          <div
            key={index}
            className="absolute top-0 bottom-0 bg-blue-500"
            style={{
              left: `${(guide.position / canvasWidth) * 100}%`,
              width: 1,
            }}
          />
        ) : (
          <div
            key={index}
            className="absolute left-0 right-0 bg-blue-500"
            style={{
              top: `${(guide.position / canvasHeight) * 100}%`,
              height: 1,
            }}
          />
        ),
      )}
    </div>
  );
}
